import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({name: 'addHourToDate'})
export class addHourToDatePipe {
  transform(value){
  		// Add 1 hour : 3600000 ms
  		return new Date((new Date(value)).getTime() + 3600000);
	}
}


// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/pipes/addHourToDate.pipe.ts